<template>
  <div>
     <!-- uploadURL+'?dropzone=1' + urlupload"  -->
     <dropzone :id="'myVueDropzone_'+dzName" ref="myVueDropzone"
     :url="computeURL"
     @vdropzone-success="showSuccess"
     :maxFileSizeInMB="(1000*2)"
     @vdropzone-success-multiple="successMulti"
     @vdropzone-sending="sending"
     @vdropzone-error="vdropzone_error"
     acceptedFileTypes="image/*,application/pdf,.docx,.xlsx"
     :useCustomDropzoneOptions="true"
     paramName="file"
     :autoProcessQueue="false"
     :useCustomSlot="true"
     >
     <!-- v-bind:preview-template="template" -->
     <!-- uploadMultiple -->
     <!-- :headers="{'content-type': 'multipart/form-data  charset=utf-8 '}"> -->
        <!-- Optional parameters if any! -->
        <!-- <input type="hidden" name="token" value="xxx"> -->
      <div class="dropzone-custom-content">
        <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
        <div class="subtitle">...or click to select a file from your computer</div>
      </div>        
    </dropzone>
      <div class="text-xs-center">
        <v-btn round color="primary" @click="upup">upload</v-btn>
      </div>
  </div>
</template>

<script>
  import Dropzone from 'vue2-dropzone'
  export default {
    name: 'drop_zone',
    props: ['book', 'list', 'dzName'],
    data () {
      return {
        // uploadURL: 'https://httpbin.org/post',
        uploadURL: process.env.VUE_APP_API_PATH + 'api/Upload3/bookUpload.asp',
        uploadedFiles: [],
        uploadError: null,
        currentStatus: null,
        uploadFieldName: 'File',
        queryString: '',
        temp: []
      }
    },
    components: {
      Dropzone
    },
    mounted: function () {
      this.$nextTick(function () {
        // Dropzone.prototype.defaultOptions.dictDefaultMessage = "-----Drop files here to upload------";
        // Dropzone.prototype.defaultOptions.dictFallbackMessage = "Your browser does not support drag'n'drop file uploads.";
        // Dropzone.prototype.defaultOptions.dictFallbackText = "Please use the fallback form below to upload your files like in the olden days.";
        // Dropzone.prototype.defaultOptions.dictFileTooBig = "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.";
        // Dropzone.prototype.defaultOptions.dictInvalidFileType = "You can't upload files of this type.";
        // Dropzone.prototype.defaultOptions.dictResponseError = "Server responded with {{statusCode}} code.";
        // Dropzone.prototype.defaultOptions.dictCancelUpload = "Cancel upload";
        // Dropzone.prototype.defaultOptions.dictCancelUploadConfirmation = "Are you sure you want to cancel this upload?";
        // Dropzone.prototype.defaultOptions.dictRemoveFile = "Remove file";
        // Dropzone.prototype.defaultOptions.dictMaxFilesExceeded = "You can not upload any more files.";
        // console.log('dropzone mounted params.id', this.$route.params.id)
        // console.log('dropzone mounted this.book', this.book)
        // console.log('dropzone mounted this.list', this.list)
        // console.log('this.$refs.myVueDropzone.url', this.$refs.myVueDropzone.url)
      })
    },
    computed: {
      computeURL() {
        // console.log('this.book', this.book)
        // console.log('this.list', this.list)
        // console.log('this.value', this.value)
        if (this.book) {
          // console.log('computeURL', this.uploadURL + '?dropzone=1' + '&id=' + this.book)
          if (this.list !== undefined) {
            return this.uploadURL + '?dropzone=1' + '&id=' + this.book + '&list=' + this.list
          }
          return this.uploadURL + '?dropzone=1' + '&id=' + this.book
        } else {
          // console.log('computeURL', this.uploadURL + '?dropzone=1')
          return this.uploadURL + '?dropzone=1'
        }
      }
    },
    methods: {
      sending (file, xhr, formData) {
        // console.log('url', this.$refs.myVueDropzone.url)
        // console.log('sending file', file.name)
        // console.log('sending xhr', xhr.responseURL)
        var fn = encodeURI(file.name)
        // formData.append('encFilename', fn)
        formData.append('filename', fn)
      },
      upup () {
        console.log('this.computeURL', this.computeURL)
        this.$refs.myVueDropzone.setOption('url', this.computeURL)
        this.$refs.myVueDropzone.processQueue()
        // console.log('getAcceptedFiles', this.$refs.myVueDropzone.getAcceptedFiles())
        // console.log('getUploadingFiles', this.$refs.myVueDropzone.getUploadingFiles())
        this.temp = this.$refs.myVueDropzone.getUploadingFiles()
        if (this.temp.length > 0) {
          this.temp = this.temp[0].xhr
        }
      },
      template () {
        return `
                <div class="dz-preview dz-file-preview">
                    <div class="dz-image" style="">
                        <img data-dz-thumbnail />
                        <div class="dz-filename"><span data-dz-name></span></div>
                        <div class="dz-size"><span data-dz-size></span></div>
                    </div>
                    <div class="dz-details"  style="">
                      <div class="dz-filename"><span data-dz-name></span></div>
                      <div class="dz-size"><span data-dz-size></span></div>
                    </div>
                    <div class="dz-progress" >
                      <span class="dz-upload" data-dz-uploadprogress></span>
                    </div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                    <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                    <div class="dz-error-mark"><i class="fa fa-close"></i></div>
                </div>
              `
      },
      successMulti (files, response) {
        // console.log('file', file)
        console.log('response', files + response)
      },
      vdropzone_error (file) {
        console.log('error', file)
      },
      showSuccess (file) {
        console.log('A file was successfully uploaded' + file)
      }
    }
  }
</script>
<style>
.dropzone {
    min-height: 80px;
    border: 2px solid rgba(0,0,0,.3);
    background: #fff;
    padding: 10px;
}
.dropzone .dz-message {
    text-align: center;
    margin: 0.5em 0;
}
.dropzone .dz-preview {
    position: relative;
    display: inline-block;
    vertical-align: top;
    margin: 5px;
    min-height: 50px;
    width:200px;
}
.dropzone .dz-preview .dz-image {
  width: 200px;
  height: 50px;
  background-color:royalblue;
  z-index: 1
}
.dropzone .dz-preview .dz-image img {
  width: fit-content;
}
.dropzone .dz-preview .dz-details {
  width: 200px;
  height: 50px;
  background-color:royalblue;
  padding: 2px;
  z-index: 1
}
.vue-dropzone .dz-preview .dz-error-mark,
.vue-dropzone .dz-preview .dz-success-mark {
    margin-left: auto!important;
    margin-top: auto!important;
    width: 100%!important;
    top: -11px!important;
    left: 70%;
}
.dropzone .dz-preview .dz-remove {
    position: absolute;
    height: 25px;
    width: 100px;
    z-index: 30;
    color: #fff;
    margin-left: 99px;
    padding: 2px;
    top: 55%;
    bottom: 15px;
    border: 2px solid #fff;
    text-decoration: none;
    text-transform: uppercase;
    font-size: .8rem;
    font-weight: 800;
    letter-spacing: 1.1px;
}
.dropzone .dz-preview .dz-progress {
    opacity: 1;
    z-index: 1000;
    pointer-events: none;
    position: absolute;
    height: 16px;
    left: 50%;
    top: 50%;
    margin-top: -8px;
    width: 80px;
    margin-left: -40px;
    background: hsla(0,0%,100%,.9);
    -webkit-transform: scale(1);
    border-radius: 8px;
    overflow: hidden;
}
</style>
